import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primaryDark text-primaryLight border-t border-iconFourth/30 pt-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pb-8 grid grid-cols-1 md:grid-cols-3 gap-12">
        {/* Left: Brand, Description, Contact */}
        <div className="flex flex-col gap-6">
          <div className="flex items-center gap-4">
            <span className="w-14 h-14 flex items-center justify-center">
              <img src="/assets/images/vital-hive-logo.png" alt="VitalHive Logo" className="w-10 h-10 object-contain" />
            </span>
            <div className="flex flex-col">
              <div className="text-2xl font-extrabold bg-gradient-to-r from-secondary via-yellow100 to-secondaryDark bg-clip-text text-transparent">
                VitalHive
              </div>
              <div className="text-sm text-primaryLight font-medium tracking-wide">
                Healthcare Staffing
              </div>
            </div>
          </div>
          <p className="text-primaryLight text-base leading-relaxed">
            Transforming healthcare through innovative digital solutions. We're dedicated to improving patient care and healthcare management with cutting-edge technology.
          </p>
          <div className="flex flex-col gap-3 mt-2">
            <div className="flex items-center gap-3">
              <i className="fas fa-map-marker-alt text-secondary text-lg"></i>
              <span>123 Healthcare Ave, Suite 100<br />Portland, ME 04101</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="fas fa-phone text-secondary text-lg"></i>
              <span>+1 (555) 123-4567</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="fas fa-envelope text-secondary text-lg"></i>
              <span>info@vitalhive.com</span>
            </div>
          </div>
        </div>

        {/* Middle: Services & Legal */}
        <div className="flex flex-col gap-8">
          <div>
            <h3 className="text-2xl font-bold text-iconInverted flex items-center gap-2 mb-4">
              <i className="fas fa-chart-bar text-secondary text-xl"></i> Services
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-lg">
                <i className="fas fa-user-nurse text-secondary"></i> For Nurses
              </li>
              <li className="flex items-center gap-3 text-lg">
                <i className="fas fa-hospital text-secondary"></i> For Facilities
              </li>
              <li className="flex items-center gap-3 text-lg">
                <i className="fas fa-chart-line text-secondary"></i> Analytics
              </li>
              <li className="flex items-center gap-3 text-lg">
                <i className="fas fa-shield-alt text-secondary"></i> Compliance
              </li>
              <li className="flex items-center gap-3 text-lg">
                <i className="fas fa-credit-card text-secondary"></i> Billing
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-bold text-iconInverted mb-2">Legal</h4>
            <ul className="space-y-1">
              <li>
                <Link to="/privacy-policy" className="hover:text-secondary transition-colors">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="hover:text-secondary transition-colors">Terms of Service</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Right: Contact Form */}
        <div>
          <h3 className="text-2xl font-bold text-iconInverted flex items-center gap-2 mb-6">
            <i className="fas fa-paper-plane text-secondary text-xl"></i> Contact Us
          </h3>
          <form className="bg-primary rounded-xl p-6 flex flex-col gap-4 shadow-soft">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1">
                <label className="block text-primaryLight text-sm mb-1">Your Name</label>
                <input type="text" placeholder="John Doe" className="w-full px-4 py-2 rounded bg-iconInverted text-primaryDark placeholder-iconTritary focus:outline-none focus:ring-2 focus:ring-secondary" />
              </div>
              <div className="flex-1">
                <label className="block text-primaryLight text-sm mb-1">Email Address</label>
                <input type="email" placeholder="john@example.com" className="w-full px-4 py-2 rounded bg-iconInverted text-primaryDark placeholder-iconTritary focus:outline-none focus:ring-2 focus:ring-secondary" />
              </div>
            </div>
            <div>
              <label className="block text-primaryLight text-sm mb-1">Message</label>
              <textarea rows={3} placeholder="Tell us about your project or questions..." className="w-full px-4 py-2 rounded bg-iconInverted text-primaryDark placeholder-iconTritary focus:outline-none focus:ring-2 focus:ring-secondary" />
            </div>
            <button type="submit" className="w-full bg-secondary text-conPrimary font-bold py-3 rounded hover:bg-secondaryDark transition-all flex items-center justify-center gap-2 text-lg">
              <i className="fas fa-paper-plane"></i> Send Message
            </button>
          </form>
        </div>
      </div>
      <div className="border-t border-iconFourth/20 pt-6 pb-4 px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-primaryLight text-sm text-center md:text-left">
          © {currentYear} VitalHive. All rights reserved.
        </div>
        <div className="flex items-center gap-2 text-primaryLight text-sm">
          Made with <span className="text-secondary text-lg">♥</span> for healthcare
        </div>
      </div>
    </footer>
  );
};

export default Footer; 